import { Injectable } from '@angular/core';
import { CsiHttp } from '../../core/csi-http';
import { environment } from '../../../environments/environment';
import { DespachoProduto } from '../model/despacho-produto';

@Injectable()
export class ControleDeEstoqueService {
  constructor(private http: CsiHttp) {}
  apiPrincipalURL = environment.principal;

  getProdutosAutoComplete(query: string) {
    let url =
      this.apiPrincipalURL + '/controleDeEstoque/getProdutosAutoComplete';
    url += '?query=' + query;
    return this.http.get(url).map((response: any) => {
      return response;
    });
  }

  getConsulta(nrDdd: number, nrTelefone: number, nrChamado: number, nrDespacho: number) {
    let url = this.apiPrincipalURL + '/controleDeEstoque/getConsulta';
    url += '?nrDdd=' + nrDdd + '&nrTelefone=' + nrTelefone + '&nrChamado=' + nrChamado + '&nrDespacho=' + nrDespacho;
    return this.http.get(url)
           .map(
                (response: any) => {
                 return response;
                 }
          );
  }

  getColunasMateriaisUtilizados(tela: string) {
    let url =
      this.apiPrincipalURL + '/controleDeEstoque/getColunasMateriaisUtilizados';
    url += '?tela=' + tela;
    return this.http.get(url).map((response: any) => {
      return response;
    });
  }

  excluirDespachoProdutoSelecionado(despachoProdutoSelecionado: DespachoProduto) {
    const url =
      this.apiPrincipalURL + '/controleDeEstoque/excluirDespachoProdutoSelecionado';
    return this.http.post(url, despachoProdutoSelecionado).map((response: any) => {
      return response;
    });
  }

  salvarDespachoProduto(despachoProduto: DespachoProduto) {
    const url =
      this.apiPrincipalURL + '/controleDeEstoque/salvarDespachoProduto';
    return this.http.post(url, despachoProduto).map((response: any) => {
      return response;
    });
  }

  getProdutoPorCodigo(codigo: number) {
    let url =
      this.apiPrincipalURL + '/controleDeEstoque/getProdutoPorCodigo';
    url += '?codigo=' + codigo;
    return this.http.get(url).map((response: any) => {
      return response;
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/commons/servicos/controle-de-estoque.service.ts